<template>
  <div class="multiple-choice">
    <el-checkbox-group v-model="issue.select">
      <div class="items-group mb-4 last:mb-0" v-for="(group, index) in issue.item_groups" :key="index">
        <div class="cg-title text-base mb-2">
          <span> {{ group.title }}</span>
        </div>
        <ul class="cg-content" :style="gridStyle">
          <li v-for="item in group.options" :key="item.id" class="mb-2 last:mb-0">
            <multiple-choice-item
              :item="item"
              :class="issue.getChoiceCheckedClass(item.id,question)"
              :selected="issue.select.includes(item.id)"
              :correct-answer-list="correctAnswerList"
              :question-id="question.id"
              :question-type="question.questionType"
              :enable-relation="item.setting.enableRelation"
              :exclusiveIds="exclusiveIds"
              :max="issue.max_choice"
            >
              <template v-slot:vote>
                <vote-progress
                    v-if="showVoteProgress && changeExpr"
                    :vote="question.vote"
                    :label="item.id"
                    :checked="issue.select.includes(item.id)"
                    :selected="!!issue.select.length"
                />
              </template>
            </multiple-choice-item>
          </li>
        </ul>
      </div>
    </el-checkbox-group>
  </div>
</template>

<script>
import MultipleChoiceItem from '@/questions/components/MultipleChoiceItem'
import VoteProgress from '@/questions/components/VoteProgress.vue'

export default {
  name: 'MultipleChoice',
  components: { VoteProgress, MultipleChoiceItem },
  changeExpr: 'changeExpr',
  computed: {
    exclusiveIds() {
      return this.issue.items.filter(i => i.is_exclusive).map(i => i.id)
    },
    correctAnswerList() {
      if (!this.view) return []
      return this.question.getCorrectAnswerList()
    },
    changeExpr() {
      return this.issue.select
        .map(id => {
          let item = this.issue.getItemById(id)
          if (item) {
            return item.id + item.value + item.content.fileList.length
          } else {
            return ''
          }
        })
        .join('-')
    },
    gridStyle() {
      if (this.issue.choice_num_per_row < 2) {
        return ''
      } else {
        return `
          display:grid;
          grid-template-columns:repeat(${this.issue.choice_num_per_row}, 1fr);
          grid-column-gap: 20px;
        `
      }
    }
  },
  methods: {
    mutexHandler(group1, group2, type) {
      let list = this.issue.select

      function isSame(id) {
        return list.includes(id)
      }

      let g1 = group1[type](isSame)
      let g2 = group2[type](isSame)
      let mutexArray = []
      if (g1) {
        mutexArray = group2
      } else if (g2) {
        mutexArray = group1
      } else {
      }

      this.issue.items.forEach(item => {
        if (item.disabled) return
        item.disabled = mutexArray.includes(item.id)
        if (item.disabled) {
          let idx = list.findIndex(id => item.id === id)
          if (idx > -1) {
            list.splice(idx, 1)
          }
        }
      })
    },
    transMutex() {
      this.issue.mutex.forEach(mutex => {
        let type = mutex.mutex_type
        let group1 = mutex.mutex_group1
        let group2 = mutex.mutex_group2
        if (type === 1) {
          this.mutexHandler(group1, group2, 'every')
        } else if (type === 2) {
          this.mutexHandler(group1, group2, 'some')
        }
      })
    }
  },
  watch: {
    'issue.select'() {
      if (this.issue.mutex.length) {
        this.issue.items.forEach(item => {
          item.disabled = false
        })
        this.transMutex()
      }
    }
  }
}
</script>
